"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orc = exports.reduxConnect = exports.connect = void 0;
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var redux_tools_1 = require("./redux-tools");
var serverData_1 = require("../utils/serverData");
function connect(pageKey, configs) {
    var _this = this;
    var preloadData = serverData_1.serverData();
    var mapStateToProps = function (state) {
        var stateToProps = {};
        Object.keys(configs).forEach(function (key) {
            stateToProps[key] = state[key] || redux_tools_1.initState[key];
        });
        return stateToProps;
    };
    function isServerRender() {
        var rs = false;
        if (preloadData && preloadData[pageKey]) {
            rs = true;
            delete preloadData[pageKey];
        }
        return rs;
    }
    var mapDispatchToProps = function (dispatch) {
        var actionsDispath = {};
        Object.keys(configs).forEach(function (key) {
            var ACTION_KEY = "$" + key;
            var actionToProps = {};
            var actions = configs[key];
            var _loop_1 = function (ak) {
                if (actions.hasOwnProperty(ak)) {
                    actionToProps[ak] = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return __awaiter(_this, void 0, void 0, function () {
                            var resK, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        resK = ak;
                                        if (ak === 'asyncData' && isServerRender()) {
                                            resK = '_asyncDataHydra';
                                        }
                                        _a = dispatch;
                                        return [4, actions[resK].apply(actions, args)];
                                    case 1:
                                        _a.apply(void 0, [_b.sent()]);
                                        return [2];
                                }
                            });
                        });
                    };
                }
            };
            for (var ak in actions) {
                _loop_1(ak);
            }
            actionsDispath[ACTION_KEY] = actionToProps;
        });
        return actionsDispath;
    };
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps);
}
exports.connect = connect;
exports.reduxConnect = function (component, _a) {
    var _b = _a.states, states = _b === void 0 ? [] : _b, _c = _a.actions, actions = _c === void 0 ? {} : _c, _d = _a.deps, deps = _d === void 0 ? [] : _d;
    if (typeof states !== 'string') {
        states = states[0];
    }
    var withDepsConfigs = {};
    withDepsConfigs[states] = actions;
    if (deps) {
        deps.forEach(function (dep) {
            var depActions = redux_tools_1.generalActions(dep);
            withDepsConfigs[dep.name] = depActions;
        });
    }
    return react_router_dom_1.withRouter(connect(states, withDepsConfigs)(component));
};
function orc(model, deps) {
    var actions = redux_tools_1.generalActions(model);
    return function (component) { return exports.reduxConnect(component, { states: model.name, actions: actions, deps: deps }); };
}
exports.orc = orc;
exports.default = connect;
//# sourceMappingURL=connect.js.map